import React from 'react'

const SvgUp = props => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="up_svg__a"
        d="M14.848 19.087L7.314 12.24a1 1 0 010-1.48l7.534-6.847a1.67 1.67 0 012.198 0 1.326 1.326 0 010 1.997l-5.338 4.85a1 1 0 000 1.48l5.338 4.85a1.325 1.325 0 010 1.997 1.634 1.634 0 01-1.1.413c-.397 0-.795-.137-1.098-.413z"
      />
    </defs>
    <use fill={props.fill} transform="rotate(90 12 11.5)" xlinkHref="#up_svg__a" />
  </svg>
)

export default SvgUp
